import { DOCUMENT } from '@angular/common';
import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, of, throwError } from 'rxjs';

/** Trusted static artwork only. WorkspaceIconsModule owns the registrations. */
@Injectable({ providedIn: 'root' })
export class BrIconRegistry {
  private readonly document = inject(DOCUMENT);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly icons = new Map<string, SVGElement>();

  addSvgIconLiteralInNamespace(namespace: string, name: string, literal: SafeHtml): this {
    if (typeof literal === 'string') throw new Error('Icon literal was not trusted as safe HTML.');
    const container = this.document.createElement('div');
    container.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, literal) ?? '';
    const svg = container.querySelector('svg');
    if (!svg) throw new Error(`Icon ${namespace}:${name} must contain an SVG element.`);
    svg.setAttribute('focusable', 'false');
    this.icons.set(`${namespace}:${name}`, svg);
    return this;
  }

  getNamedSvgIcon(name: string, namespace = ''): Observable<SVGElement> {
    const svg = this.icons.get(`${namespace}:${name}`);
    return svg ? of(svg.cloneNode(true) as SVGElement)
      : throwError(() => new Error(`Unable to find icon ${namespace}:${name}.`));
  }
}
